import produce from "immer";
import { ReportsActions } from ".";
import { IStoreState } from "../initialStoreState";
import { defaultReports, defaultReportsState } from "./default";
import { CLEAR_REPORTS_STATE, CLEAR_REPORTS, FETCH_REPORTS_LIST_FAILED, FETCH_REPORTS_LIST_PROGRESS, FETCH_REPORTS_LIST_SUCCESS } from "./reportsActions";
import { LoadState } from "../../constants/enums";







export const reportsReducer = (
  state: IStoreState["reports"] = defaultReportsState,
  action: ReportsActions
) => {
  switch (action.type) {
    case FETCH_REPORTS_LIST_PROGRESS: {
         const newState = produce(state, (draftState) => {
           draftState.reports.loading = LoadState.InProgress;
           draftState.list.data = [];
           draftState.reports.data = defaultReports;
         });
         return newState;
       }
       case FETCH_REPORTS_LIST_SUCCESS: {
         const { data,  singleReport,totalRecords, totalamount } = action.payload;
         const newState = produce(state, (draftState) => {
           draftState.reports.loading = LoadState.Loaded;
           draftState.reports.data = singleReport;
           draftState.list.data = data;
            draftState.amount.totalamount = totalamount;
           draftState.list.totalRecords = totalRecords;
         });
         return newState;
       }
       case FETCH_REPORTS_LIST_FAILED: {
         const newState = produce(state, (draftState) => {
           draftState.reports.loading = LoadState.Failed;
           draftState.list.data = [];
           draftState.reports.data = defaultReports;
         });
         return newState;
       }
       case CLEAR_REPORTS_STATE: {
        return defaultReportsState;
       }
      
       default: {
        return state;
      }
  }
  
};